import React from 'react';
import { Puzzle } from 'lucide-react';

const IntegrationSection = () => {
  return (
    <section className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#d4896a' }}>
      <div className="max-w-5xl mx-auto">
        <div className="text-center">
          <h3 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold text-white mb-6 sm:mb-8 leading-tight">
            "Practice Dashboard plugs directly into your existing Practice CS environment. This means there's no need to switch systems or disrupt your workflow—just add Practice Dashboard and enhance the features you rely on every day."
          </h3>
          
          <div className="flex flex-col sm:flex-row items-center justify-center text-white text-lg sm:text-xl">
            <Puzzle className="w-5 h-5 sm:w-6 sm:h-6 mb-2 sm:mb-0 sm:mr-3" />
            <span className="font-medium">Part of TS Practice CS ecosystem</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntegrationSection;